import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [NgIf],
  templateUrl: './theme-toggle.component.html'
})
export class ThemeToggleComponent {
  protected readonly i18n = inject(TranslationService);
  @Input({ required: true }) isDark = false;
  @Output() toggle = new EventEmitter<void>();

  protected onToggle(): void {
    this.toggle.emit();
  }
}
